import type { PrioritiesState } from 'shared/interfaces/priority.interface';

import { createSlice } from '@reduxjs/toolkit';

import { getPrioritiesThunk } from './priorities.thunks';

const initialState: PrioritiesState = {
  list: [],
};

const prioritiesSlice = createSlice({
  name: 'priorities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrioritiesThunk.fulfilled, (state, action) => {
      state.list = action.payload.rows;
    });
  },
});

export const prioritiesReducer = prioritiesSlice.reducer;
